import { ReactNode } from "react";
import { InnerPropertiesProvider } from "./inner-properties-provider";
import { ProvidePropertiesByTemplateCode } from "./provide-property-by-template-code";
import { ProvidePropertyByTemplateId } from "./provide-property-by-template-id";

export function PropertyProvider({
  children,
  code,
  properties,
  templateId,
}: {
  code?: string;
  children: ReactNode;
  properties?: string[];
  templateId?: string;
}) {
  if (code) {
    return (
      <ProvidePropertiesByTemplateCode code={code}>
        {children}
      </ProvidePropertiesByTemplateCode>
    );
  }

  if (templateId) {
    return (
      <ProvidePropertyByTemplateId templateId={templateId}>
        {children}
      </ProvidePropertyByTemplateId>
    );
  }

  if (properties) {
    return (
      <InnerPropertiesProvider properties={properties}>
        {children}
      </InnerPropertiesProvider>
    );
  }
}
